import React, { useCallback, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import Preloader from '../../components/Preloader/Preloader'
import { AuthContext } from '../../context/firebase-context'
import createVideoProject from '../../common/create-video-project'
const WEB_HOST = process.env.REACT_APP_WEB_HOST

const VerifyContainer = () => {
  const navigate = useNavigate()
  const user = useContext(AuthContext)

  const processProject = useCallback(async () => {
    if (!user) {
      window.location.href = `${WEB_HOST}/login`
      return
    }
    const uuid = await createVideoProject(user)
    if (uuid) {
      navigate(`/video-editor/${uuid}`)
    }
  }, [user])

  useEffect(() => {
    processProject()
  }, [])

  return (
    <Preloader />
  )
}

export default VerifyContainer
